import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

export const EMPTY_QUEUE_HUB_FILTERS = {
  number: "",
  origin: "",
  destination: "",
  shipperName: "",
  onlyWithQueue: true,
};

export function buildHubQueryParams(filters, user) {
  const params = {
    onlyWithQueue: filters.onlyWithQueue !== false,
  };

  if (filters.number?.trim()) params.numberSerial = filters.number.trim();
  if (filters.origin?.trim()) params.origem = filters.origin.trim();
  if (filters.destination?.trim()) params.destino = filters.destination.trim();
  if (filters.shipperName?.trim()) {
    params.shipperName = filters.shipperName.trim();
  }

  if (user?.uidShipper) params.uidShipper = user.uidShipper;
  if (Array.isArray(user?.uidShipperAffiliates) && user.uidShipperAffiliates.length) {
    params.affiliates = user.uidShipperAffiliates.join(",");
  }
  if (typeof user?.viewALL === "boolean") {
    params.viewAll = String(user.viewALL);
  }

  return params;
}

export function mapTransportQueueHubFreights(hubResponse) {
  const freights = Array.isArray(hubResponse?.freights) ? hubResponse.freights : [];

  return freights
    .map((freight) => {
      const queue = (Array.isArray(freight.queue) ? freight.queue : [])
        .map((candidate) => ({
          rowKey: `${freight.freightId}_${candidate.idCarrier}`,
          idCarrier: candidate.idCarrier,
          nameCarrier: candidate.nameCarrier,
          cnpj: candidate.cnpj,
          registeredAt: candidate.registeredAt,
        }))
        .sort(
          (a, b) =>
            new Date(a.registeredAt || 0) - new Date(b.registeredAt || 0),
        );

      return {
        freightId: freight.freightId,
        numberSerial: freight.numberSerial,
        origin: freight.origin,
        destination: freight.destination,
        collectionDate: freight.collectionDate,
        freightValue: freight.freightValue,
        shipperUid: freight.shipperUid,
        shipperName: freight.shipperName,
        status: freight.status,
        queueCount: queue.length,
        queue,
        oldestRegisteredAt: queue[0]?.registeredAt ?? null,
      };
    })
    .filter((freight) => freight.queueCount > 0)
    .sort((a, b) => {
      const dateA = new Date(a.oldestRegisteredAt || a.collectionDate || 0);
      const dateB = new Date(b.oldestRegisteredAt || b.collectionDate || 0);
      return dateA - dateB;
    });
}

/** @deprecated Prefer mapTransportQueueHubFreights for grouped UI */
export function flattenTransportQueueHubRows(hubResponse) {
  const freights = Array.isArray(hubResponse?.freights) ? hubResponse.freights : [];
  const rows = [];

  freights.forEach((freight) => {
    const queue = Array.isArray(freight.queue) ? freight.queue : [];
    queue.forEach((candidate) => {
      rows.push({
        rowKey: `${freight.freightId}_${candidate.idCarrier}`,
        freightId: freight.freightId,
        numberSerial: freight.numberSerial,
        origin: freight.origin,
        destination: freight.destination,
        collectionDate: freight.collectionDate,
        freightValue: freight.freightValue,
        shipperUid: freight.shipperUid,
        shipperName: freight.shipperName,
        status: freight.status,
        idCarrier: candidate.idCarrier,
        nameCarrier: candidate.nameCarrier,
        cnpj: candidate.cnpj,
        registeredAt: candidate.registeredAt,
      });
    });
  });

  return rows.sort(
    (a, b) => new Date(a.registeredAt || 0) - new Date(b.registeredAt || 0),
  );
}

export function groupRowsByFreight(rows) {
  const map = new Map();

  rows.forEach((row) => {
    if (!map.has(row.freightId)) {
      map.set(row.freightId, {
        freightId: row.freightId,
        numberSerial: row.numberSerial,
        shipperUid: row.shipperUid,
        queue: [],
      });
    }
    const group = map.get(row.freightId);
    group.queue.push({
      idTransport: row.idCarrier,
      name: row.nameCarrier,
      cnpj: row.cnpj,
      registeredAt: row.registeredAt,
    });
  });

  return [...map.values()];
}

export function formatCurrency(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatDateBr(dateStr) {
  if (!dateStr) return "—";
  if (String(dateStr).includes("/")) return dateStr;
  const [year, month, day] = String(dateStr).split("-");
  if (!year || !month || !day) return dateStr;
  return `${day}/${month}/${year}`;
}

export function formatWaitingTime(registeredAt) {
  if (!registeredAt) return "—";
  try {
    const date = new Date(registeredAt);
    if (Number.isNaN(date.getTime())) return "—";
    return formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
  } catch {
    return "—";
  }
}

export function formatOldestWaiting(minutes) {
  if (!minutes || minutes <= 0) return "—";
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest > 0 ? `${hours}h ${rest}min` : `${hours}h`;
}
